import type { ReactNode } from 'react';

export const StrikethroughPrice = ({ children }: { children: ReactNode }) => (
  <s className="relative whitespace-nowrap text-tertiary no-underline after:absolute after:inset-x-0 after:top-1/2 after:h-px after:-translate-y-1/2 after:bg-current forced-colors:line-through forced-colors:after:hidden">
    {children}
  </s>
);
